import { Box, Container, HStack, Heading, Text, Stack } from "@chakra-ui/react"
import { memo } from "react"
import { Proposition } from "@components/Sections/UniqueSellingProposition/Proposition"
import { CustomImage } from "@components/Image"
import { BoxCalloutItem } from "./BoxCalloutItem"
import { useContent } from "@app/hooks/useContent"
import { useMedia } from "@app/hooks/useMedia"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import { CarouselOverflowWrapper, extraOverflowParentProps } from "@app/components/CarouselOverflowWrapper"
import { useSanityImageUrl } from "@app/hooks/useSanity"

const BoxCallout: React.FC<GatsbyTypes.SanitySectionBoxCallout> = ({
  bgColor,
  checklist,
  title,
  image,
  boxCallouts,
  subtitle: rawSubtitle,
}) => {
  const { getContent } = useContent()
  const subtitle = getContent({ content: rawSubtitle })
  const { isLarge, isMedium } = useMedia()
  const { getSanityImageUrl } = useSanityImageUrl()

  const imgUrl = image?.asset?.url && isLarge ? getSanityImageUrl(image?.asset?.url, 380, 450) : ""

  return (
    <Box bgColor={bgColor}>
      <Box pt={12}>
        <Container>
          <Heading as="p" size={["h3", "h2"]} textAlign="center" pb={6}>
            {title}
          </Heading>
          <Stack
            direction={["column", "column", "row"]}
            alignItems={["center", "center", "auto"]}
            spacing={[1, 1, 6, 12]}
            justifyContent="center"
            pb={4.5}
          >
            {checklist?.map((item: any) => (
              <Proposition key={item?._key} {...item} showDivider={false} fontSize={["sm", "xl"]} noLetterSpacing />
            ))}
          </Stack>
        </Container>
      </Box>
      <Box pb={8} {...extraOverflowParentProps}>
        {isMedium && (
          <HStack spacing={6} justifyContent="center">
            {isLarge && <CustomImage src={imgUrl} alt={image?.alt} />}
            <HStack spacing={6} alignItems="stretch">
              {boxCallouts?.map((callout: any) => (
                <BoxCalloutItem key={callout?._key} {...callout} />
              ))}
            </HStack>
          </HStack>
        )}
        {!isMedium && (
          <CarouselOverflowWrapper type="boxCallout">
            <Swiper modules={[Navigation]} navigation pagination={{ clickable: true }} slidesPerView="auto" centeredSlides initialSlide={1}>
              {boxCallouts?.map((callout: any) => (
                <SwiperSlide key={callout?._key} className="no-flex">
                  <BoxCalloutItem {...callout} />
                </SwiperSlide>
              ))}
            </Swiper>
          </CarouselOverflowWrapper>
        )}
        <Container>
          <Text textAlign={["center", "right", "center"]} pt={5}>
            {subtitle}
          </Text>
        </Container>
      </Box>
    </Box>
  )
}

export default memo(BoxCallout)
